function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { INPUT } from "../../components/form-styles";
import { listImageAssets, uploadImage, searchProducts, isMissing, friendly } from "./compose-api";

/*
 * Image control for hero / image+text sections (2026-10-04). Five sources:
 * Upload (file → Content Hub upload, composer route as fallback), Content Hub
 * (recent image assets, searchable), Brand logo, Product image (search), URL.
 * Shows the current image as a thumbnail with Remove. `value` is the URL;
 * `onChange(url, meta)` where meta = {source, productId?, assetId?}.
 */

export default class ImagePicker extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "loadAssets", async q => {
      try {
        const items = await listImageAssets(q);
        if (this._alive) this.setState({
          assets: items,
          assetsHidden: false
        });
      } catch (e) {
        if (!this._alive) return;
        if (isMissing(e)) this.setState({
          assets: [],
          assetsHidden: true
        });else this.setState({
          assets: [],
          err: friendly(e, "The Content Hub library couldn't be read right now.")
        });
      }
    });
    _defineProperty(this, "loadProducts", async q => {
      try {
        const items = await searchProducts(q);
        if (this._alive) this.setState({
          products: items,
          productsHidden: false
        });
      } catch (e) {
        if (!this._alive) return;
        if (isMissing(e)) this.setState({
          products: [],
          productsHidden: true
        });else this.setState({
          products: [],
          err: friendly(e, "Product search isn't available right now.")
        });
      }
    });
    _defineProperty(this, "onFile", async e => {
      const f = e.target.files && e.target.files[0];
      e.target.value = "";
      if (!f) return;
      if (!/^image\//.test(f.type)) {
        this.setState({
          err: "Pick an image file (jpg, png, webp or gif)."
        });
        return;
      }
      if (f.size > 10 * 1024 * 1024) {
        this.setState({
          err: "Images up to 10 MB."
        });
        return;
      }
      this.setState({
        busy: true,
        err: null
      });
      try {
        const r = await uploadImage(f);
        if (!this._alive) return;
        this.setState({
          busy: false,
          tab: null
        });
        this.props.onChange(r.url, {
          source: "upload",
          assetId: r.id
        });
      } catch (x) {
        if (this._alive) this.setState({
          busy: false,
          err: friendly(x, "The upload didn't go through. Try again or paste a URL.")
        });
      }
    });
    this.state = {
      tab: null,
      busy: false,
      err: null,
      assets: null,
      assetsHidden: false,
      aq: "",
      products: null,
      productsHidden: false,
      pq: "",
      url: ""
    };
    this._alive = true;
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._t);
  }
  open(tab) {
    this.setState({
      tab: this.state.tab === tab ? null : tab,
      err: null,
      url: this.props.value || ""
    });
    if (tab === "hub" && this.state.assets == null) this.loadAssets("");
    if (tab === "product" && this.state.products == null) this.loadProducts("");
  }
  debounce(fn, q) {
    clearTimeout(this._t);
    this._t = setTimeout(() => fn(q), 250);
  }
  pick(url, meta) {
    this.setState({
      tab: null,
      err: null
    });
    this.props.onChange(url, meta);
  }
  render() {
    const {
      value,
      brand,
      label
    } = this.props;
    const {
      tab,
      busy,
      err,
      assets,
      assetsHidden,
      products,
      productsHidden
    } = this.state;
    const logo = brand && brand.logoUrl;
    const T = ({
      k,
      children
    }) => /*#__PURE__*/React.createElement("a", {
      className: "mtf-chip" + (tab === k ? " on" : ""),
      style: {
        cursor: "pointer"
      },
      onClick: () => this.open(k)
    }, children);
    return /*#__PURE__*/React.createElement("div", {
      className: "cmp-img"
    }, label ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-label"
    }, label) : null, /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-row"
    }, value ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-thumb"
    }, /*#__PURE__*/React.createElement("img", {
      src: value,
      alt: "",
      onError: e => {
        e.target.style.opacity = .25;
      }
    }), /*#__PURE__*/React.createElement("a", {
      className: "cmp-img-x",
      title: "Remove image",
      onClick: () => this.pick("", {
        source: "none"
      })
    }, "\xD7")) : /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-thumb empty"
    }, "no image"), /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-opts"
    }, /*#__PURE__*/React.createElement("label", {
      className: "mtf-chip",
      style: {
        cursor: busy ? "wait" : "pointer"
      }
    }, busy ? "Uploading…" : "Upload", /*#__PURE__*/React.createElement("input", {
      type: "file",
      accept: "image/*",
      style: {
        display: "none"
      },
      disabled: busy,
      onChange: this.onFile
    })), !assetsHidden ? /*#__PURE__*/React.createElement(T, {
      k: "hub"
    }, "Content Hub") : null, logo ? /*#__PURE__*/React.createElement("a", {
      className: "mtf-chip",
      style: {
        cursor: "pointer"
      },
      onClick: () => this.pick(logo, {
        source: "brandLogo"
      })
    }, "Brand logo") : null, !productsHidden ? /*#__PURE__*/React.createElement(T, {
      k: "product"
    }, "Product image") : null, /*#__PURE__*/React.createElement(T, {
      k: "url"
    }, "URL"))), err ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-warn"
    }, err) : null, tab === "url" ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-panel row"
    }, /*#__PURE__*/React.createElement("input", {
      style: {
        ...INPUT,
        flex: "1 1 200px"
      },
      autoFocus: true,
      placeholder: "https://\u2026/image.jpg",
      value: this.state.url,
      onChange: e => this.setState({
        url: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter") this.pick(this.state.url.trim(), {
          source: "url"
        });
      }
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      style: {
        marginTop: 0
      },
      onClick: () => this.pick(this.state.url.trim(), {
        source: "url"
      })
    }, "Use")) : null, tab === "hub" ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-panel"
    }, /*#__PURE__*/React.createElement("input", {
      style: INPUT,
      autoFocus: true,
      placeholder: "Search your image library",
      value: this.state.aq,
      onChange: e => {
        this.setState({
          aq: e.target.value
        });
        this.debounce(this.loadAssets, e.target.value);
      }
    }), assets == null ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "Loading\u2026") : !assets.length ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "No images ", this.state.aq ? "match" : "in the library yet", ". Upload one, or add media under Content Hub.") : /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-grid"
    }, assets.map(a => /*#__PURE__*/React.createElement("a", {
      key: a.id,
      className: "cmp-img-cell",
      title: a.title,
      onClick: () => this.pick(a.url, {
        source: "contentHub",
        assetId: a.id
      })
    }, /*#__PURE__*/React.createElement("img", {
      src: a.thumb,
      alt: a.title,
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("span", null, a.title || "untitled"))))) : null, tab === "product" ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-panel"
    }, /*#__PURE__*/React.createElement("input", {
      style: INPUT,
      autoFocus: true,
      placeholder: "Search products by name or SKU",
      value: this.state.pq,
      onChange: e => {
        this.setState({
          pq: e.target.value
        });
        this.debounce(this.loadProducts, e.target.value);
      }
    }), products == null ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "Loading\u2026") : !products.length ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "No products match.") : /*#__PURE__*/React.createElement("div", {
      className: "cmp-img-grid"
    }, products.filter(p => p.imageUrl).map(p => /*#__PURE__*/React.createElement("a", {
      key: p.id,
      className: "cmp-img-cell",
      title: p.title,
      onClick: () => this.pick(p.imageUrl, {
        source: "product",
        productId: p.id,
        productUrl: p.url,
        productTitle: p.title
      })
    }, /*#__PURE__*/React.createElement("img", {
      src: p.imageUrl,
      alt: p.title,
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("span", null, p.title))))) : null);
  }
}